import {
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import "./App.css"; // Ensure your styles are properly imported
import CheckCircleFilledIcon from "./components/icons/CheckCircleFilledIcon"; // Import the CheckCircleFilledIcon component
import Topbar from "./components/Topbar"; // Import the Topbar component

const planList = [
  "Upload CSV file from Property Radar or PropStream",
  "Instantly remove duplicates, fix formatting, and clean addresses",
  "No subscriptions",
  "Fast, secure, and 100% automated",
  "Files are limited to 20, 000 rows per upload.",
];

const Pricing = () => {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(133.06deg, #FFFFFF 43.43%, #EBECEE 107.05%)",
        minHeight: "100vh",
        position: "relative",
        zIndex: 1,
        overflow: "hidden",
        pb: "50px",
      }}
    >
      {/* Top Navigation Bar */}
      <Topbar />

      {/* Main Content Centered Like Exclusions Page */}
      <Container>
        <Box maxWidth="md" mx="auto" mt="72px">
          <Typography variant="h1" textAlign={"center"}>
            Pricing
          </Typography>
          {/* Description Text */}
          <Typography
            variant="body1"
            textAlign={"center"}
            color="#8B8B8B"
            mt={1.5}
            sx={{ textWrap: "balance" }}
          >
            Instant List Cleaning for{" "}
            <strong style={{ color: "#F69133" }}>Just $20 Per File</strong>
          </Typography>

          <Box mx="auto" mt={"50px"} maxWidth={"782px"}>
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={{
                p: { xs: "30px 16px", md: "30px 46px" },
                boxShadow:
                  "0.72px 15.22px 33.33px 0px rgba(171, 171, 171, 0.1),4.35px 60.87px 60.87px 0px rgba(171, 171, 171, 0.09),9.42px 136.22px 81.88px 0px rgba(171, 171, 171, 0.05),17.39px 242.02px 97.1px 0px rgba(171, 171, 171, 0.01),26.81px 378.24px 106.52px 0px rgba(171, 171, 171, 0)",
                border: "1px solid #F69133",
                backgroundColor: "#fff",
                borderRadius: "20px",
                gap: { xs: "24px", md: "30px" },
                flexDirection: { xs: "column", md: "row" },
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "50%",
                  left: "-100%",
                  width: "200vw",
                  height: "100vh",
                  backgroundColor: "#ECEDEF",
                  zIndex: -1,
                },
              }}
            >
              <Box>
                <Typography
                  fontSize={12}
                  fontWeight={600}
                  lineHeight={1}
                  backgroundColor="#F69133"
                  color="#fff"
                  textAlign="center"
                  borderRadius="100px"
                  padding="8px 20px"
                  noWrap
                  display={"inline-flex"}
                >
                  Simple Pricing
                </Typography>

                <Typography
                  variant="body3"
                  component={"h2"}
                  mt={"14px"}
                  fontWeight={500}
                  noWrap
                >
                  <span
                    style={{
                      fontSize: "34px",
                      color: "#F69133",
                      fontWeight: 800,
                    }}
                  >
                    $
                  </span>
                  <span style={{ fontSize: "60px", fontWeight: 800 }}>20</span>
                  /per list
                </Typography>
                <Typography color="#505050" variant="body8">
                  One-time payment
                </Typography>

                <Button
                  variant="contained"
                  color="default"
                  disableElevation
                  sx={{
                    mt: "20px",
                    textWrap: "nowrap",
                    minWidth: "min(80vw, 252px)",
                  }}
                  component={Link}
                  to="/upload"
                >
                  Upload & Clean Your List Now
                </Button>
              </Box>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{
                  display: { xs: "none", md: "block" },
                  border: "none",
                  width: "1px",
                  opacity: "0.21",
                  background:
                    "linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #333333 52.51%, rgba(0, 0, 0, 0) 100%)",
                }}
              />

              <Box>
                <List dense sx={{ padding: 0 }}>
                  {planList.map((item, index) => (
                    <ListItem
                      key={index}
                      alignItems="flex-start"
                      disablePadding
                    >
                      <ListItemIcon sx={{ minWidth: "24px" }}>
                        <CheckCircleFilledIcon />
                      </ListItemIcon>
                      <ListItemText
                        slotProps={{
                          primary: {
                            variant: "body4",
                          },
                        }}
                      >
                        {item}
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>

            <Typography
              variant="body4"
              color="#505050"
              mt={"25px"}
              textAlign={"center"}
              sx={{ textWrap: "balance" }}
            >
              If your file exceeds this limit, please contact us at{" "}
              <a
                href="mailto:support@realestatelistcleaner.com"
                style={{
                  color: "#F69133",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                support@realestatelistcleaner.com
              </a>{" "}
              for assistance.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Pricing;
